module.exports = __webpack_public_path__ + "img/Italian-Installation-step2.9a2fc002.png";